// extracted by mini-css-extract-plugin
module.exports = {"root":"PreloaderWrapper_root__kr4T8"};